import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sync-set-confirmation-popup',
  standalone: false,
  templateUrl: './sync-set-confirmation-popup.html',
  styleUrls: ['./sync-set-confirmation-popup.scss']
})
export class SyncSetConfirmationPopup {
  action: string;
  title: string;
  type: string;
  constructor(
    private readonly dialogRef: MatDialogRef<SyncSetConfirmationPopup>,
    @Inject(MAT_DIALOG_DATA) public data: { action: string, title: any, type: string }) {
    this.action = data.action;
    this.title = data.title
    this.type = data.type;
  }
  close() {
    this.dialogRef.close(false);
  }

  confirmStatusChange() {
    this.dialogRef.close(true);
  }
}